import Link from 'next/link'
import React from 'react'

export const LabelWithLink = ({ href, text, mt = false }: { href: string; text: string; mt?: boolean }) => {
  return (
    <>
      <div className={`text-center text-sm sm:mb-4 sm:flex sm:flex-wrap ${mt ? 'mt-5' : ''}`}>
        <Link href={href} passHref={true} legacyBehavior={true}>
          <a className="flex-2" target="_new" rel="noopener">
            {text}
          </a>
        </Link>
      </div>
    </>
  )
}
